export function broadcastActivity() {
    if (typeof BroadcastChannel !== 'undefined') {
        try {
            const bc = new BroadcastChannel('auth');
            bc.postMessage({ type: 'activity', ts: Date.now() });
            bc.close();
        } catch (err) {}
    } else {
        try {
            localStorage.setItem('prism_activity', Date.now());
        } catch (e) {}
    }
}


